module.exports = __webpack_public_path__ + "star-98c50c4f.webp";